import React from "react";
import style from "./Button.module.css";

export default function Button(props) {
  const { onClick, loading } = props;
  return (
    <div className={style.divBtn}>
      <button disabled={loading} onClick={onClick} className={style.btn}>
        {loading ? <div className={style.loader}></div> : "ورود"}
      </button>
    </div>
  );
}
